import * as actions from '../actions/actionTypes'
import { IBookmakerOptionsState, IState } from '../store/state';

const bookmakerOptions = (state : IBookmakerOptionsState = {}, action:any) : IBookmakerOptionsState => {
  switch (action.type) {
    case actions.FETCH_BOOKMAKER_OPTIONS_SUCCEDED:
      return Object.assign({}, state, action.data)
    default:
      return state
  }
}

export const getBookmakerOptions = (state:IState) => {
  if (!Object.keys(state.bookmakerOptions).length) {
    return {}
  }
  return state.bookmakerOptions.bookmakerInstances
}

export const getVideoOptions = (state:IState) => {
  if (!Object.keys(state.bookmakerOptions).length) {
    return {}
  }
  const videoOptions = {
    videoset : state.bookmakerOptions.bookmakerInstances.videoOptions.videoset,
    serverName : state.bookmakerOptions.bookmakerInstances.videoOptions.server,
    serverApplicationUrl : state.bookmakerOptions.bookmakerInstances.videoOptions.applicationurl,
    key: state.bookmakerOptions.bookmakerInstances.videoOptions.key
  }
  return videoOptions
}

// returns the environment configured in the backend ("Testing", "Staging" or "Production")
export const getEnvironment = (state: IState) => {
  return state.bookmakerOptions.bookmakerInstances.environment;
}

// holds base url to Trondheim feeds
export const getFeedBaseUrl = (state : IState) => {
  return state.bookmakerOptions.bookmakerInstances.externalFeedBaseUrl;
}

// holds base url to statistic center
export const getStatisticCenterBaseUrl = (state : IState) => {
  return state.bookmakerOptions.bookmakerInstances ? state.bookmakerOptions.bookmakerInstances.statisticCenterBaseUrl: null;
}

export default bookmakerOptions